<template>
  <div
    class="radio-button form-check form-check-radio"
    :class="[inlineClass, { disabled: disabled }]"
  >
    <label :for="cbId" class="btn form-check-label" 
    :style="[label == model ? styleClass.active : styleClass.normal]"
    
     >
      <input
        :id="cbId"
        class="form-check-input"
        type="radio"
        :disabled="disabled"
        :value="label"
        v-model="model"
      />
      <slot></slot>
    </label>
  </div>
</template>
<script>
export default {
  name: 'n-radio-button',
  props: {
    label: [String, Number],
    disabled: Boolean,
    value: [String,Number, Boolean,Array],
    inline: Boolean,
    styleClass:Object,
  },
  data() {
    return {
      cbId: ''
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    inlineClass() {
      if (this.inline) {
        return `form-check-inline`;
      }
      return '';
    }
  },
  created() {
    this.cbId = Math.random()
      .toString(16)
      .slice(2);
  }
};
</script>
